import React from "react";
import "./TermsAndCondition.css";

export function TermsAndCondition() {
  return (
    <div className="tnc__main">
      <h1 className="tnc__header">Terms of Service</h1>
      <p className="tnc__content">
        These Terms of Service constitute the entire agreement between you and
        “Searates Connect” and govern your use of the Service, superseding any
        prior agreements between you and “Searates Connect” with respect to the
        Service. You also may be subject to additional terms and conditions that
        may apply when you use affiliate or third party services, third party
        content or third party software. These Terms of Service will be governed
        by the laws of the State of California without regard to its conflict of
        law provisions. With respect to any disputes or claims not subject to
        arbitration, as set forth above, you and “Searates Connect” agree to
        submit to the personal and exclusive jurisdiction of the state and
        federal courts located within Santa Clara County, California. The
        failure of “Searates Connect” to exercise or enforce any right or
        provision of these Terms of Service will not constitute a waiver of such
        right or provision. If any provision of these Terms of Service is found
        by a court of competent jurisdiction to be invalid, the parties
        nevertheless agree that the court should endeavor to give effect to the
        parties' intentions as reflected in the provision, and the other
        provisions of these Terms of Service remain in full force and effect.
        You agree that regardless of any statute or law to the contrary, any
        claim or cause of action arising out of or related to use of the Service
        or these Terms of Service must be filed within one (1) year after such
        claim or cause of action arose or be forever barred. A printed version
        of this agreement and of any notice given in electronic form will be
        admissible in judicial or administrative proceedings based upon or
        relating to this agreement to the same extent and subject to the same
        conditions as other business documents and records originally generated
        and maintained in printed form. You may not assign this Terms of Service
        without the prior written consent of “Searates Connect”, but “Searates
        Connect” may assign, sublicense, or transfer any or all of its rights
        and obligations under this Terms of Service without restriction. The
        section titles in these Terms of Service are for convenience only and
        have no legal or contractual effect. Notices to you may be made via
        either email or regular mail. The Service may also provide notices to
        you of changes to these Terms of Service or other matters by displaying
        notices or links to notices generally on the Service.
      </p>
    </div>
  );
}
